import './ContractExplorerPage.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {Typography} from "@mui/material";
import {MainPageFacade} from "~/components/main/page/MainPageFacade.tsx";
import {CARD_CONFIG} from "~/components/dashboard/DashboardCardConfigs.tsx";
import {useStores} from "~/stores";
import {ContractDetailView} from "./ContractDetailView.tsx";
import {ContractListView} from "./ContractListView.tsx";
import {useContractListParams} from "./useContractListParams.ts";

/**
 * Contract Intelligence: the databag's bundles as cat-contract-extract
 * built and linked them, imported into cat-material and shown read-only. The
 * list and one bundle share this route; which one shows is the `contract`
 * query param, so Back returns to the list as it was.
 */
export const ContractExplorerPage: React.FC = observer(() => {
    const {bagStore, p} = useStores();
    const bagId = bagStore.bagId;
    const {params, update} = useContractListParams();
    const openContract = React.useCallback((id: number | null) => update({contract: id}), [update]);

    return (
        <MainPageFacade
            title={params.contract ? '' : <Typography component="h1" variant="h5" fontWeight={700}>{CARD_CONFIG['contract-explorer'].title}</Typography>}
            titleTag={params.contract ? undefined : p.cardTag('contract-explorer')}
            className="contract-explorer-page ci">
            {params.contract
                ? <ContractDetailView
                    bagId={bagId}
                    contractId={params.contract}
                    tab={params.tab}
                    links={params.links}
                    onTab={tab => update({tab})}
                    onLinks={links => update({links})}
                    onOpenContract={openContract}
                    onBack={() => openContract(null)}/>
                : <ContractListView bagId={bagId} params={params} update={update}/>}
        </MainPageFacade>
    );
});
